@if (patientDossier() | authorization: endpoint : 'read') {
    <curafida-card
        #curafidaCardComponent
        (setActionButton)="addRelationship()"
        [actionButtons]="actionButtons"
        [title]="'USER.' + managedUserRole() + '.SINGULAR'"
        class="full-width no-left-right-margin">
        <ion-card-content>
            <curafida-table
                (setActionOnItem)="setActionOfTable($event)"
                [isLoading]="isLoading"
                [listTableConfig]="listConfig"></curafida-table>
            <div
                [hidden]="isButtonHidden()"
                class="button-container">
                @if (!isEditEnabled && (patientDossier() | authorization: endpoint : 'write')) {
                    <ion-button
                        (click)="isEditEnabled = true"
                        [ngClass]="{ 'btn-font-medium': !isMobile(), 'full-width': isMobile() }"
                        data-testid="edit-button"
                        >{{ 'EDIT' | translate }}</ion-button
                    >
                }
                @if (isEditEnabled) {
                    <ion-button
                        (click)="isEditEnabled = false"
                        [ngClass]="{ 'btn-font-medium': !isMobile(), 'half-width': isMobile() }"
                        color="danger"
                        >{{ 'CANCEL' | translate }}</ion-button
                    >
                }
            </div>
        </ion-card-content>
    </curafida-card>
}
